import React, { Component } from "react";
import { Tabs } from "antd";

import LadderTable from "./LadderTable";

import * as laddersList from "../assets/js/laddersList.json";

const { TabPane } = Tabs;

export default class LaddersList extends Component {
	render() {
		return (
			<div className="LaddersList">
				<Tabs defaultActiveKey="1" tabPosition="top">
          {laddersList.ladders.map((ladder, index) => {
						let solved = 0;
						ladder.problems.forEach(problem => {
							if (this.props.solved.has(`${problem.idContest}/${problem.indexProblem}`))
								++solved;		
						});
						return (
							<TabPane tab={ ladder.title } key={index + 1}>				
								<h4>Solved: { solved }</h4>
								<LadderTable dataLadder={ ladder } solved={ this.props.solved } />
							</TabPane>
						);
					})}
        </Tabs>
			</div>
		);
	}
}
